import { Link, useNavigate, useParams } from "react-router-dom";
import patient from "../../../../assets/img/patient.jpg";
import React, { useEffect, useRef, useState } from "react";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { ToastContainer } from "react-toastify";
import Textarea from "../../../../components/text-area";
import {
  ADMINPROMPTS,
  ADMINTEMPLATE,
  DIAGONASTIC_TOOL,
  PRACTICE_FRAMEWORK,
} from "../../../../action/apiPath";
import { CallWithAuth } from "../../../../action/apiActions";
import { showToast } from "../../../../util/toastHelper";
import Loading from "react-fullscreen-loading";
import { ADMINPROMPTPAGE, ADMINTEMPLATEPAGE } from "../../../../util/path";
import { ADMIN } from "../../../../util/constant";

const MySwal = withReactContent(Swal);

/**
 * The Patient Relatives Information Page component
 * @returns {JSX.Element} The component
 */

const AdminTemplatesPageAddOrEdit = ({ ...props }) => {
  const { isEdit, setSampleReports, refetch } = props;

  const { id } = useParams();

  console.log("isEdit", isEdit);

  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const textareaRef = useRef(null);
  const [practiceFrameworks, setPracticeFrameworks] = useState([]);
  const [diagnostic_tool, setDiagnosticTool] = useState([]);

  const [apiEndpointNameList, setApiEndpointNameList] = useState([
    { value: "collateral", level: "Collateral" },
    { value: "background_info", level: "Background Information" },
    { value: "mse", level: "Mental Status Examination (MSE)" },
    { value: "standardised_assessment", level: "Standardised Assessment" },
    { value: "clinical_interviews", level: "Clinical Interviews" },
    { value: "formulation", level: "Formulation" },
    { value: "diagnose", level: "Diagnosis" },
    { value: "recommendation", level: "Recommendation" },
    { value: "recommendations", level: "Suggestions" },
    { value: "assessment_data", level: "Assessment Data" }
  ]);

  const [formData, setFormData] = useState({
    template_name: "",
    selectRole: "",
    templatePrompts: [],
  });

  React.useEffect(() => {
    if (id && isEdit) {
      getSpecificPrompts();
    } else {
      setIsLoading(false);
    }
  }, [id, isEdit]);

  React.useEffect(() => {
    if (id && isEdit && refetch) {
      if (refetch == 1) {
        getSpecificPrompts();
      } else if (refetch == 2) {
        setIsLoading(true);
      }
    } else {
      setIsLoading(false);
    }
  }, [id, isEdit, refetch]);

  const getSpecificPrompts = async () => {
    try {
      if (!id) return;

      setIsLoading(true);
      const response = await CallWithAuth("GET", `${ADMINTEMPLATE}/${id}`);

      if (response.res.status === 200) {
        const apiData = response.res?.data?.data;

        // set sample reports
        setSampleReports(apiData?.example_reports || []);

        // Fill main template info
        const updatedPrompts = apiEndpointNameList.map((endpoint) => {
          const existing = apiData?.templatePrompts?.find(
            (p) => p.apiEndpointName === endpoint.value
          );
          const existingId = apiData?.templatePrompts?.find(
            (p) => p.apiEndpointName === endpoint.value
          )?.id;
          return {
            apiEndpointName: endpoint.value,
            promtText: existing ? existing.promtText : "",
            id: existingId || null,
          };
        });

        setFormData({
          template_name: apiData?.template_name || "",
          selectRole: apiData?.templatePrompts[0]?.selectRole || "",
          templatePrompts: updatedPrompts,
        });
      } else {
        showToast("error", response.res.data.message);
      }

      setIsLoading(false);
    } catch (err) {
      console.error("Error fetching prompt data:", err);
      setIsLoading(false);
    }
  };


  const adjustHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // Reset height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set new height based on scrollHeight
    }
  };

  const practiceFrameworksApiCall = async () => {
    try {
      const response = await CallWithAuth("GET", PRACTICE_FRAMEWORK);
      if (response.res.data && response.res.data.statusCode === 200) {
        setPracticeFrameworks(response.res.data.data);
      }
    } catch (error) {
      console.error("Error fetching practice frameworks:", error);
    }
  };
  const diagonastictoolApiCall = async () => {
    try {
      const response = await CallWithAuth("GET", DIAGONASTIC_TOOL);
      if (response.res.data && response.res.data.statusCode === 200) {
        setDiagnosticTool(response.res.data.data);
      }
    } catch (error) {
      console.error("Error fetching practice frameworks:", error);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    practiceFrameworksApiCall();
    diagonastictoolApiCall();
  }, []);
  // Re-run on text change
  const [prompt, setPrompt] = useState({});

  useEffect(() => {
    adjustHeight(); // Adjust height on initial render
  }, [prompt]);
  //   useEffect(() => {
  //     getPromptData();
  //   }, []);
  //   const getPromptData = async () => {
  //     try {
  //       const response = await CallWithAuth("GET", ADMINPROMPTS);
  //       if (response.res.status == 200) {
  //         setPrompt((prev) => ({
  //           ...prev,
  //           background_info: response.res.data.data.background_info,
  //           collateral: response.res.data.data.collateral,
  //           mse: response.res.data.data.mse,
  //           standardised_assessment:
  //             response.res.data.data.standardised_assessment,
  //           clinical_interviews: response.res.data.data.clinical_interviews,
  //           formulation: response.res.data.data.formulation,
  //           diagnose: response.res.data.data.diagnose,
  //           recommendation: response.res.data.data.recommendation,
  //         }));
  //         // setPrompt(response.res.data.data);
  //       } else {
  //         showToast("error", response.res.data.message);
  //       }
  //       setIsLoading(false);
  //     } catch (err) {
  //       setIsLoading(false);
  //     }
  //   };

  const validatePromptData = (data) => {
    const errors = {};

    if (!formData.selectRole) {
      errors.selectRole = "Doctor role is required.";
    }

    // if (!formData.practiceFrameworkId) {
    //   errors.practiceFrameworkId = "Practice framework is required.";
    // }

    // if (!formData.diagnosticToolId) {
    //   errors.diagnosticToolId = "Diagnostic tool is required.";
    // }

    if (!formData.apiEndpointName) {
      errors.apiEndpointName = "API endpoint name is required.";
    }

    if (!formData.promtText || formData.promtText.trim() === "") {
      errors.promtText = "Prompt text is required.";
    }

    return errors;
  };
  const savePrompts = async () => {
    if (!formData.selectRole) {
      showToast("error", "Select Role is required.");
      return;
    }
    if (!formData.template_name.trim()) {
      showToast("error", "Template Name is required.");
      return;
    }
    if (!formData.templatePrompts.length) {
      showToast("error", "Please fill all prompt text fields.");
      return;
    }
    for (const prompt of formData.templatePrompts) {
      if (!prompt.promtText || prompt.promtText.trim() === "") {
        showToast("error", `Prompt for "${prompt.apiEndpointName}" is required.`);
        return;
      }
    }

    const payload = {
      id: isEdit ? id : null,
      template_name: formData.template_name,
      selectRole: formData.selectRole,
      templatePrompts: formData.templatePrompts.map((p) => ({
        id: isEdit ? p?.id : null,
        apiEndpointName: p.apiEndpointName,
        promtText: p.promtText,
      })),
    };

    console.log("Final Payload:", payload);

    const method = isEdit ? "PATCH" : "POST";
    const url = ADMINTEMPLATE;

    setIsLoading(true);
    const response = await CallWithAuth(method, url, payload);
    setIsLoading(false);

    if (response.res.status === 200 || response.res.status === 201) {
      showToast("success", response.res.data.message);
      navigate(ADMINTEMPLATEPAGE);
    } else {
      showToast("error", response.res.data.message);
    }
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleRoleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleFrameworkChange = (e) => {
    setFormData({
      ...formData,
      practiceFrameworkId: e.target.value,
    });
  };
  const handleDiagnosticToolChange = (e) => {
    setFormData({
      ...formData,
      diagnosticToolId: e.target.value,
    });
  };

  const handleApiEndpointChange = (e) => {
    setFormData({
      ...formData,
      apiEndpointName: e.target.value,
    });
  };
  return (
    <>
      {isLoading && (
        // <><h1 className="text-center">Report loading...</h1></>
        <>
          <Loading
            loading
            background="rgba(236, 240, 241, 0.7)"
            loaderColor="#3498db"
          />
        </>
      )}

      <section class="create_account_block">
        <div class="site_container">
          <div class="create_account_form">
            <div class="field_block">
              <label for="">Select Role</label>
              <div class="input_check_grp">
                <div class="item">
                  <input
                    type="radio"
                    name="selectRole"
                    value="psychiatrist"
                    checked={formData?.selectRole === "psychiatrist"}
                    onChange={handleRoleChange}
                  />
                  <span>psychiatrist </span>
                </div>
                <div class="item">
                  <input
                    type="radio"
                    name="selectRole"
                    value="psychologist"
                    checked={formData?.selectRole === "psychologist"}
                    onChange={handleRoleChange}
                  />
                  <span>psychologist </span>
                </div>
              </div>
            </div>

            <div className="field_block">
              <label>Template Name</label>
              <input
                type="text"
                className="form-control"
                name="template_name"
                value={formData?.template_name || ""}
                onChange={handleChange}
                placeholder="Enter Template Name"
              />
            </div>

            {/* Loop all API endpoint levels with textarea */}
            {apiEndpointNameList.map((endpoint, index) => (
              <div className="field_block" key={endpoint.value}>
                <label>
                  {endpoint.level} <span style={{ color: "red" }}>*</span>
                </label>
                <Textarea
                  name={endpoint.value}
                  value={formData?.templatePrompts?.find(
                    (item) => item.apiEndpointName === endpoint.value
                  )?.promtText || ""}
                  onChange={(e) => {
                    const { value } = e.target;
                    setFormData((prev) => {
                      const updatedPrompts = [...(prev.templatePrompts || [])];
                      const existingIndex = updatedPrompts.findIndex(
                        (p) => p.apiEndpointName === endpoint.value
                      );
                      if (existingIndex !== -1) {
                        updatedPrompts[existingIndex].promtText = value;
                      } else {
                        updatedPrompts.push({
                          apiEndpointName: endpoint.value,
                          promtText: value,
                        });
                      }
                      return {
                        ...prev,
                        templatePrompts: updatedPrompts,
                      };
                    });
                  }}
                  
                />
              </div>
            ))}

            <button onClick={savePrompts} className="button_save_prompts">
              {isEdit ? "Update" : "Save Template"}
            </button>
          </div>
        </div>
      </section>
      {/* <section className="site_container">
          <div className="row mx-auto mt-5">
            <div className="col-12 prompts_inner_block">
              <Textarea
                name="background_info"
                value={prompt.background_info}
                onChange={handleChange}
                fieldName="background info"
              />
            </div>

            
            <button onClick={savePrompts} className="button_save_prompts mt-5">
              Save Prompts
            </button>
          </div>
        </section> */}
    </>
  );
};
export default AdminTemplatesPageAddOrEdit;
